export const LogoMark = ({ className = "w-9 h-9", dark = false }) => {
  const stroke = dark ? "#E4C491" : "#451230";
  const fill = dark ? "#E4C491" : "#C08A45";
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true" data-testid="logo-mark">
      <path d="M15 5h18l10 10v18l-10 10H15L5 33V15L15 5Z"
        stroke={stroke} strokeWidth="3.5" strokeLinejoin="round" />
      <path d="M21.5 14h5v7.5h7.5v5h-7.5V34h-5v-7.5H14v-5h7.5V14Z" fill={fill} />
    </svg>
  );
};
